
import { cn } from "../lib/utils";

import { 
  
  Dialog as HeadlessDialog,

  DialogBackdrop as HeadlessDialogBackdrop,
  
  DialogPanel as HeadlessDialogPanel, 
  
  DialogTitle as HeadlessDialogTitle

} from '@headlessui/react'


const Dialog = ( { className, ...props } ) => {
  
  return (

    <HeadlessDialog

      className={ cn( "relative z-50", className ) }

      { ...props }

    />

  )

}

const DialogBackdrop = ( { className, ...props } ) => {

  return (

    <HeadlessDialogBackdrop

      className={ cn( "fixed inset-0 bg-black/50 duration-300 ease-out data-closed:opacity-0", className ) }

      transition="true"

      { ...props }

    />

  )

}

const DialogPanel = ( { className, ...props } ) => {

  return (

    <HeadlessDialogPanel

      className={ cn( 
        
        "max-w-3xl w-full bg-blue-fresh px-6 sm:px-9 pb-5 sm:pb-9 pt-5 grid grid-cols-1 sm:grid-cols-[auto_auto] items-center justify-center gap-y-2 sm:gap-x-8", 
        
        className 
      
      ) }

      transition="true"

      { ...props }

    />

  )

}

const DialogTitle = ( { className, ...props } ) => {

  return (

    <HeadlessDialogTitle

      className={ cn( "text-white", className ) }

      { ...props }

    />

  )

}

export {

  Dialog,

  DialogBackdrop,
  
  DialogPanel,
  
  DialogTitle,

}